/* @flow */

import React from 'react';
import { Header, Grid, Message, Card, Icon } from 'semantic-ui-react';
import ResourceImage from 'shared/components/ResourceImage';

type Props = {
  block: EditorialBlock,
};

const View = ({ block, onSerialize }: Props) => {
  if (block.pdf) {
    return (
      <Grid columns={2} textAlign="center">
        <Grid.Column>
          <Header as="h3" content={block.caption} />
          <Card centered>
            <ResourceImage resource={block.pdf.resource} />
            <Card.Content extra>
              <a
                href={block.pdf.resource.url.original}
                target="_blank"
                rel="noopener noreferrer"
                icon="file pdf outline"
                className="ui labeled fluid icon basic button"
              >
                <Icon name="file pdf outline" />
                Télécharger
              </a>
            </Card.Content>
          </Card>
        </Grid.Column>
      </Grid>
    );
  }

  return <Message icon="info" header="Aucun PDF spécifié" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/pdf/View.js